import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DoctorSocialService } from '../doctor-social.service';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { BoostPostDialogComponent } from './boost-post-dialog/boost-post-dialog.component';

@Component({
  selector: 'app-insights-dialog',
  templateUrl: './insights-dialog.component.html',
  styleUrls: ['./insights-dialog.component.css']
})
export class InsightsDialogComponent implements OnInit {

  insights;

  constructor(
    public dialogRef: MatDialogRef<InsightsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private service: DoctorSocialService,
    private toaster: ToastrService,
    public app: AppService
  ) { }

  ngOnInit(): void {
    this.getPostInsights();
  }

  getPostInsights() {
    this.service.getInsights(this?.data?.id).subscribe(
      res => {
        this.insights = res.data
      }
    )
  }

  cancel(): void {
    this.dialogRef.close();
  }

  dialogBoost() {
    let id = this?.data?.id
    const dialogRef = this.dialog.open(BoostPostDialogComponent, {
      width: '700px',
      data: { id },
      panelClass: 'modalBoxScroll'
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == true) {

      }
    });
    this.cancel();
  }

}
